const tag = (tagJson) => {
  const properties = {
    ...tagJson.attributes,
    guid: tagJson.guid,
  };
  return Object.assign(properties);
};

export default tag;
